<div class="main-page">
  <div class="newclas">
    <div class="row">
      <div class="col">
        <!-- <app-header></app-header> -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <!-- <app-side-bar [user]="merchantDetail"></app-side-bar> -->
      </div>
      <div class="col-md-10 mx-auto">
        <div class="innerPage mainPage">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="main-box">
              <h6 class="text-white d-flex justify-content-between">
                Location Greeting
                <!-- Default checked -->

                <div class="custom-control custom-switch"><span>{{
                    form.get("iswelcomeMessage")?.value ? "Enabled" : "Disabled"
                  }}</span>
                  <input
                    type="checkbox"
                    formControlName="iswelcomeMessage"
                    (change)="isWelcomeMessage($event)"
                    class="custom-control-input"
                    id="customSwitch1"
                    checked
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch1"
                  ></label>
                  <p *ngIf="form.get('iswelcomeMessage')?.value">(Disable to modify)</p>
                </div>

              </h6>
              <div class="form-group">
                <!-- [attr.disabled]="iswelcomeMessage ? '' :null"  -->
                <textarea
                  placeholder="Welcome to our business"
                  class="form-control text-areabox"
                  formControlName="welcomeMessages"
                  rows="3"
                  [(ngModel)]="greetingTitle"
                  id="comment"
                ></textarea>
                <div style="text-align: right">
                  <p style="margin-bottom: -1rem; color: #fff" class="small">
                    {{ greetingTitle.length || 0 }}/100
                  </p>
                </div>
              </div>
              <div class="form-group" style="float: right">
                <button
                  type="submit"
                  class="btn greetingBtn btn-block font-weight-bold"
                  style="background-color: green;width: 155px;"
                >
                  <span style="font-size: 14px;">Save Greeting</span>
                </button>
              </div>
              <div class="timeline-box">
                <div>
                  <div class="text-white">Set Radius (yards) {{ newVal }}</div>
                </div>
                <div class="form-group range-wrap">
                  <input
                    type="range"
                    formControlName="radius"
                    class="custom-range"
                    min="newVal"
                    max="150"
                    id="ex6"
                    (change)="setRange()"
                  />
                  <output class="bubble"></output>
                </div>
              </div>
              <div>
                <div
                  formArrayName="days"
                  *ngFor="
                    let item of form.get('days')['controls'];
                    let i = index
                  "
                >
                  <div [formGroupName]="i">
                    <div class="body-card">
                      <div class="card margin-b">
                        <div
                          class="card-header header-style main-backgroundcolor"
                        >
                          <div class="form-check form-check-inline dayInputDiv">
                            <input
                              class="form-check-input margin-t"
                              formControlName="isDaysSelected"
                              (change)="onChange($event, 'days')"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                            />
                            <label
                              class="form-check-label margin-l text-white font-weight-bold h4"
                              for="inlineCheckbox1"
                              >{{ item.get("dayName").value }}</label
                            >
                          </div>
                        </div>
                        <div
                          class="card-body1"
                          style="
                            padding: 6px;
                            display: flex;
                            justify-content: space-evenly;
                          "
                        >
                          <div class="form-check form-check-inline mb-1">
                            <input
                              class="form-check-input margin-t"
                              (change)="onChange($event, 'hours', i)"
                              formControlName="is24Hours"
                              type="checkbox"
                              id="inlineCheckbox1"
                              style="margin-top: unset"
                            />
                            <label
                              class="form-check-label"
                              style="font-size: 18px; margin-left: 10px"
                              for="inlineCheckbox1"
                            >
                              24 Hours</label
                            >
                          </div>
                          <div class="time-picker">
                            <div
                              class="form-row"
                              style="display: flex; font-size: smaller"
                            >
                              <div class="col start_time ml-4">
                                <label class="ml-4">Start Time</label>
                                <timepicker
                                  class="timepicker"
                                  [disabled]="arr[i].is24Hours"
                                  formControlName="StartTime"
                                >
                                </timepicker>
                              </div>
                              <div class="col start_time">
                                <label class="ml-4">End Time</label>
                                <timepicker
                                  [disabled]="arr[i].is24Hours"
                                  formControlName="EndTime"
                                >
                                </timepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
